import React from 'react'
import Helmet from 'react-helmet'
import { graphql } from 'gatsby'

import Layout from '../components/layout'

import Prompt from '../components/Blocks/Prompt'
import Hero from '../components/Hero';
import OurPromise from '../components/Blocks/OurPromise';
import TheBestHotels from '../components/Blocks/TheBestHotels';
import Comparison from '../components/Blocks/Comparison';
import Reviews from '../components/Blocks/Reviews';
import MediaLogos from '../components/Blocks/MediaLogos';
import SubscriptionCalculator from '../components/Blocks/SubscriptionCalculator';

import homeHero from '../images/homeHero.jpg'; // Used in meta tags
class PricingPage extends React.Component {

  processHeroQueryData(rawData) {
    const data = { ...rawData.data };

    // Extract the first available image
    rawData.media.forEach((media) => {
      if (/^image\//.test(media.file.contentType) && !data.image) {
        data.image = media.file.url;
      }
    });

    return data;
  };

  render() {
    const heroData = this.processHeroQueryData(this.props.data.contentfulConfigurationItem);

    return (
      <Layout startNavTransparent={true}>

        <Helmet>
          <title>BeRightBack - Pricing</title>
          <meta
            name="description"
            content="BRB is the world's first travel subscription service. Pay monthly and get a break in Europe every 4 months to a surprise destination."
          />
          <meta
            name="keywords"
            content="travel, be right back, brb, BRB, surprise, europe, holidays, subscription, flights, accommodation, hotel, app, travel agent, pricing"
          />
          <meta name="robots" content="index, follow" />
          <meta property="og:type" content="product" />
          <meta
            property="og:title"
            content="BRB: The world's first travel subscription"
          />
          <meta property="og:url" content="https://berightback.travel/pricing" />
          <meta property="og:image" content={homeHero} />
        </Helmet>

        <Hero
          image={heroData.image}
          title={heroData.title}
          text={heroData.text}
          video={heroData.video}
          cta={heroData.cta}
        />

        <Prompt dataName='Pricing - intro' />

        <SubscriptionCalculator />
        <TheBestHotels />
        <Comparison />
        <Reviews />
        <MediaLogos />
        <OurPromise />

      </Layout>
    );
  }
}

export default PricingPage


export const pageQuery = graphql`
{
  contentfulConfigurationItem(name: {eq: "Pricing - hero"}) {
    name
    data {
      title
      text
      cta {
        label
        link
        to
        type
      }
    }
    media {
      file {
        contentType
        url
      }
    }
  }
}
`;
